<template>
  <help-info-wrapper
    :info.sync="helpData"
    :service-name="serviceName"
    class="warp"
  >
    <template>
      <v-overlay :value="isAutoSaving" z-index="9999" opacity="0.8" v-if="AutoSave">
        <div class="text-center d-flex flex-column align-center justify-center">
          <atom-spinner :animation-duration="1500" :size="100" class="mx-auto" color="#038118"/>
          <h3 class="mt-4 green--text">در حال ذخیره سازی خودکار...</h3>
          <p class="green--text mt-2">لطفاً چند لحظه صبر کنید</p>
        </div>
      </v-overlay>

      <v-row class="pa-2" no-gutters>
        <!-- تب‌های پیش‌نمایش، دانلود و تعرفه -->
        <v-col class="pa-2 mb-4 sticky-md" cols="12" md="4" style="top: 12px">
          <v-tabs
            v-model="qrShow"
            background-color="grey lighten-3 pa-1"
            class="rounded-pill mx-auto pa-1"
            color="primary"
            height="48"
            style="width: fit-content"
          >
            <v-tab :disabled="e6 <= 1" :ripple="true">مشاهده QR</v-tab>
            <v-tab :ripple="true">پیش نمایش</v-tab>
            <v-tab :ripple="true" :disabled="e6 <= 1">تعرفه‌ها</v-tab>
          </v-tabs>
        </v-col>

        <v-col v-show="$vuetify.breakpoint.mdAndUp" cols="8" />

        <v-col
          class="pa-2 sticky-md"
          cols="12"
          md="4"
          style="top: 110px; height: fit-content"
        >
          <v-tabs-items
            v-model="qrShow"
            class="overflow-visible mb-4 mb-md-0"
            touchless
          >
            <!-- مشاهده و دانلود QR -->
            <v-tab-item>
              <qr-maker :loading="loading" />
              <div class="rowinfo">
                <v-btn
                  class="btn-download contnetinfo"
                  @click="showDialog = true"
                >
                  <v-icon>mdi-progress-download</v-icon>
                  {{ $t("download_qr") }}
                </v-btn>
                <help-info
                  :element-name="`${serviceName}-${componentName}-data-downloadQr`"
                  :help-data="helpData"
                  :service-name="serviceName"
                  class="buttoninfo"
                  label="دانلود کیوآر"
                />
              </div>
            </v-tab-item>

            <!-- پیش‌نمایش قالب -->
            <v-tab-item>
              <component
                :is="theme"
                :order.sync="cardTexts.order"
                v-model="cardTexts"
                :components="specialInfo"
                :qr-svg-data-url="qrSvgDataUrl"
              />
            </v-tab-item>

            <!-- تعرفه‌ها -->
            <v-tab-item v-if="!!info?.id && e6 > 1">
              <Tariffs :id_qr="info.id" :qrtype="'pricelabel'" />
            </v-tab-item>
          </v-tabs-items>
        </v-col>

        <!-- استپر ساخت -->
        <v-col class="pa-2 px-0" cols="12" md="8">
          <v-stepper v-model="e6" class="px-0 mx-0 qr-stepper" flat vertical>
            <!-- مرحله اول: نام و آدرس -->
            <v-stepper-step :complete="e6 > 1" class="px-0 px-md-4" step="1">
              <div class="row justify-center">
                <div class="col-md-12">
                  <p>وارد کردن اطلاعات لیبل قیمت</p>
                </div>
                <div class="col-md-6 mt-0 pt-0 rowinfo">
                  <v-text-field
                    v-model="cardTexts.visitName"
                    :disabled="e6 > 1"
                    append-icon="mdi-pen"
                    class="mt-0 pt-0 contentinfo"
                    clear-icon="mdi-close-circle-outline"
                    clearable
                    dense
                    label="نام لیبل قیمت"
                    outlined
                  />
                  <help-info
                    :element-name="`${serviceName}-${componentName}-visitName`"
                    :help-data="helpData"
                    :service-name="serviceName"
                    class="buttoninfo"
                    label="نام لیبل"
                  />
                </div>
                <div class="col-md-6 mt-0 pt-0 rowinfo">
                  <qr-address-field
                    id="qr-address"
                    ref="address-field"
                    v-model="dtUrl"
                    :disabled="e6 > 1"
                    :error-messages="errors['identifier']"
                    append-icon="mdi-web"
                    class="mt-0 pt-0 contentinfo"
                    dense
                    :key="$t('qrAddressUpdate.hints.allowedChars')"
                    :hint="$t('qrAddressUpdate.hints.allowedChars')"
                    outlined
                    persistent-hint
                    @updateDest="domainId = $event"
                  />
                  <help-info
                    :element-name="`${serviceName}-${componentName}-dtUrl`"
                    :help-data="helpData"
                    :service-name="serviceName"
                    class="buttoninfo"
                    label="آدرس کیوآر"
                  />
                </div>
              </div>
            </v-stepper-step>

            <v-stepper-content step="1">
              <div class="col-md-12">
                <next-btn
                  :loading="loading"
                  style="background: #1b8d39"
                  @click="markQr"
                />
              </div>
            </v-stepper-content>

            <!-- مرحله دوم: اطلاعات و رنگ -->
            <v-stepper-step :complete="e6 > 2" class="px-0 px-md-4" step="2">
              اطلاعات قیمت و قالب
            </v-stepper-step>

            <v-stepper-content class="pr-1 mx-0 mr-md-7 px-md-4" step="2">
              <div class="d-flex row mx-0 my-2">
                <v-btn
                  :disabled="e6 > 2"
                  class="my-4"
                  color="third"
                  outlined
                  @click="clearDefaults"
                >
                  <v-icon class="me-2">mdi-delete</v-icon>
                  حذف اطلاعات پیشفرض
                </v-btn>
                <help-info
                  :element-name="`${serviceName}-${componentName}-clearDefaults`"
                  :help-data="helpData"
                  :service-name="serviceName"
                  label="حذف اطلاعات پیش‌فرض"
                />
              </div>

              <!-- سوئیچ ذخیره خودکار -->
              <div class="mb-4 mx-4">
                <div class="d-flex align-center">
                  <v-switch
                    v-model="AutoSave"
                    color="primary"
                    class="mt-0 pt-0 shrink"
                    hide-details
                    label="ذخیره خودکار"
                  />
                  <v-tooltip bottom max-width="320">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        icon
                        x-small
                        class="mr-1"
                        v-bind="attrs"
                        v-on="on"
                        @click.stop
                      >
                        <v-icon small color="grey darken-1">
                          mdi-help-circle-outline
                        </v-icon>
                      </v-btn>
                    </template>
                    <span>
                      تغییرات هر بخش با بستن آن بخش به‌صورت خودکار ذخیره می‌شود.
                    </span>
                  </v-tooltip>
                </div>
              </div>

              <!-- لیست آکاردئونی فقط شامل اطلاعات قیمت و رنگ -->
              <list-expansion
                v-model="cardTexts"
                :component-name="componentName"
                :components="specialInfo"
                :data="cardTexts"
                :service-name="serviceName"
                flat
                @save-required="AutoSave && qrUpdate(false)"
              />

              <div class="col-md-12">
                <next-btn
                  :loading="loading"
                  style="background: #1b8d39"
                  @click="qrUpdate(true)"
                />
              </div>
            </v-stepper-content>
          </v-stepper>

          <div class="d-none">
            <qr-code-make
              v-if="e6 > 1"
              ref="qrCanvas"
              v-model="qrDesign"
              :file.sync="qrSvgDataUrl"
              :link="fullLink"
              @save="qrDesign = $event"
            />
          </div>
        </v-col>

        <!-- دیالوگ دانلود -->
        <custom-popup
          v-model="showDialog"
          :cons="cons"
          hide-confirm
          max-width="900"
          transition="dialog-bottom-transition"
        >
          <template v-slot:helpinfo>
            <help-info
              :element-name="`${serviceName}-${componentName}-data-show-download-d`"
              :help-data="helpData"
              :service-name="serviceName"
              class="buttoninfo"
              label="دانلود کیوآر"
            />
          </template>
          <v-card class="pa-5">
            <download-file-with-api
              v-if="showDialog"
              :address="`${info?.domain?.name || 'qrland.in/'}${info?.identifier}`"
              :qr_id="info.qrId"
              :visit-name="cardTexts.visitName"
            />
          </v-card>
        </custom-popup>
          <QrIntroModal
                storageKey="pricelabelIntroSeen"
                title="کیوآر لیبل قیمت"
                :pro="false"
                icon="mdi-card-outline"
                iconColor="green darken-2"
                :description="introText"
              />

      </v-row>
    </template>
  </help-info-wrapper>
</template>

<script>
import { getLanguageCookie } from "../../../core/plugins/TitleRibbon/utils/languageCookie";
import HelpInfo from "../qrland/components/helpAcordion/HelpInfo.vue";
import HelpInfoWrapper from "../qrland/components/helpAcordion/HelpInfoWrapper.vue";
import QrMaker from "../qrland/components/qrMaker";
import { Bus } from "@/main";
import ListExpansion from "../../content/fragments/listExpansion";
import NextBtn from "../../content/fragments/nextBtn";
import PrevBtn from "../../content/fragments/prevBtn";
import QrAddressField from "../../content/fragments/qrAddressField";
import QrCodeMake from "@/view/pages/qrland/qrCodeStyle/qrCodeMake.vue";
import priceLabelTheme from "./components/priceLabelTheme.vue";
import { mapActions } from "vuex";
import DownloadFileWithApi from "../qrland/downloadFileWithApi.vue";
import Tariffs from "../../components/Tariffs/Tariffs.vue";
import { AtomSpinner } from "epic-spinners";
import QrIntroModal from "../QrIntroModal.vue";

export default {
  name: "PriceLabelCreate",

  components: {
    HelpInfo,
    HelpInfoWrapper,
    QrCodeMake,
    QrAddressField,
    PrevBtn,
    NextBtn,
    ListExpansion,
    DownloadFileWithApi,
    QrMaker,
    priceLabelTheme,
    Tariffs,
    AtomSpinner,
    QrIntroModal
  },

  data() {
    return {
      introText: `
        <strong>لیبل قیمت QR</strong> یک راهکار هوشمند و مدرن برای مدیریت، به‌روزرسانی آنلاین و نمایش قیمت محصولات و تنوع‌های کالایی شماست. با این ابزار، می‌توانید اطلاعات قیمت، تخفیف‌ها و مشخصات کالا را بدون نیاز به چاپ مجدد لیبل به‌صورت لحظه‌ای مدیریت کنید.
        <br><br>
        <strong>قابلیت‌های کلیدی:</strong>
        <br>
        <span style="padding-right: 15px; display: block;">
          <strong>۱. بروزرسانی زنده و آنی:</strong> تغییر قیمت فروش، قیمت مصرف‌کننده و درصد تخفیف به صورت انلاین و خودکار در پیش‌نمایش و کد QR بدون نیاز به چاپ مجدد.<br>
          <strong>۲. مدیریت تنوع و برند:</strong> درج کامل اطلاعات برند، فروشگاه، جنس محصول و مشخصات تکمیلی کالا به همراه محاسبه هوشمند قیمت نهایی.<br>
          <strong>۳. شفافیت و اعتماد مشتری:</strong> ارائه پیش‌نمایش شفاف از تخفیف‌ها و قیمت‌های مصرف‌کننده جهت افزایش اطمینان و سرعت در خرید مشتریان.
        </span>
        <br>
        این کیوآر بهترین ابزار برای فروشگاه‌های فیزیکی، هایپرمارکت‌ها، نمایشگاه‌ها و کسب‌وکارهایی است که می‌خواهند برچسب قیمت محصولات خود را مدرن، هوشمند و همیشه به‌روز نگه‌دارند.
      `,
      isAutoSaving: false,
      AutoSave: false,
      helpData: [],
      serviceName: "Qrland",
      componentName: "price-label-card",
      theme: "priceLabelTheme",
      qrDesign: {},
      cons: { title: "دانلود کیوآر لیبل قیمت" },
      e6: 1,
      errors: {},
      createdDomain: null,
      createdId: null,
      loading: false,
      showDialog: false,

      specialInfo: [
        {
          name: "priceLabelInfo",
          value: "",
          title: "اطلاعات قیمت محصول",
          icon: "currency-usd",
          model: "label",
        },
        {
          name: "imageUploader",
          value: "",
          title: "افزودن تصویر",
          subtitle: "",
          icon: "cloud-upload-outline",
          model: "photo",
        },
        {
          name: "colorPallete",
          value: "",
          title: "انتخاب رنگ",
          icon: "format-color-fill",
          model: "pallete",
          secondName: "",
        },
      ],

      dtUrl: null,
      domainId: null,
      cardTexts: {
         photo: {
        profile: "https://qrland.ir/wp-content/uploads/2026/06/%D9%86%D9%85%D9%88%D9%86%D9%87-%D8%A7%D9%88%D9%84-%DA%A9%D8%A7%D8%B1%D8%AA-%D9%88%DB%8C%D8%B2%DB%8C%D8%AA-nfc-%D8%A7%D9%85%D9%84%D8%A7%DA%A9.webp",
        profileRatio: 1, 
        background: "https://cdn.terminalads.com/upload/64b2bb1c4ad38.webp",
        headBackground: "",
        gallery: [
      {
        images: [],
      },
    ],
  },
        order: [
          { name: "brand" },
          { name: "price" },
          { name: "bPrice" },
          { name: "cPrice" },
          { name: "discount" },
          { name: "discriptions" },
        ],
        pallete: {
          headColor: "linear-gradient(to top left , #D4AF37FF, #00616479)",
          bodyColor: "linear-gradient(to top left , #D4AF376C, #08597F5A)",
          textColor: "#294377 ",
          borderColor: "#393939",
        },
        profile: "https://qrland.ir/wp-content/uploads/2026/06/%D9%86%D9%85%D9%88%D9%86%D9%87-%D8%A7%D9%88%D9%84-%DA%A9%D8%A7%D8%B1%D8%AA-%D9%88%DB%8C%D8%B2%DB%8C%D8%AA-nfc-%D8%A7%D9%85%D9%84%D8%A7%DA%A9.webp",
        label: {
          name: { text: "فروشگاه کیوآرلند", line: false },
          labelName: { text: "کارت ویزیت هوشمند NFC املاک - طرح یک", line: false },
          brand:{ text: "ترمینال تبلیغات آدز", line: false },
          price: { text: 210000, line: false },
          bPrice: { text: 270000, line: false },
          cPrice: { text: 280000, line: false },
          discount: { text: 15, line: false },
          discriptions: { text: `جنس	
Pvc

تکنولوژِی	
NFC , QR Code

فضا ذخیره سازی	
1 کیلو بایت

فرکانس	
13/56 مگاهرتز

نوع کیو آر کد	
داینامیک ( قابلیت تغییر اطلاعات )`, line: false },
        },
        visitName: "لیبل قیمت",
      },
      qrShow: 1,
      qrSvgDataUrl: "",
      info: null,
    };
  },

  computed: {
    fullLink() {
      return this.createdDomain?.replace("/", "") + "/" + this.createdId;
    },
  },

  mounted() {
  const savedLanguage = getLanguageCookie() || "fa";
  this.$i18n.locale = savedLanguage;

  Bus.$on("colorPalette", (value) => {
    this.cardTexts.pallete = value;
  });

  Bus.$on("uploader", (value) => {
    if (value) {
      this.$set(this.cardTexts, "photo", Object.assign({}, this.cardTexts.photo, value));

      // هر زمان عکس پروفایل آپدیت شد، نسبت ابعاد را دقیق استخراج می‌کنیم
      if (value.profile) {
        this.calculateAndSetProfileRatio(value.profile);
      }
    }
  });

  if (this.cardTexts.photo?.profile) {
    this.calculateAndSetProfileRatio(this.cardTexts.photo.profile);
  }
  },
beforeDestroy() {
  Bus.$off("uploader");
},
  methods: {
    ...mapActions("local", [
      "updateQrInfo",
      "updateQridentifier",
      "updateQrDomain",
      "updateQrId",
    ]),
calculateAndSetProfileRatio(imgUrl) {
    if (!imgUrl) return;
    const img = new Image();
    img.src = imgUrl;
    img.onload = () => {
      const naturalWidth = img.naturalWidth || img.width;
      const naturalHeight = img.naturalHeight || img.height;
      if (naturalWidth && naturalHeight) {
        const ratio = parseFloat((naturalWidth / naturalHeight).toFixed(3));
        this.$set(this.cardTexts.photo, "profileRatio", ratio);
      }
    };
  },
    markQr() {
      if (
        !this.dtUrl ||
        typeof this.$refs["address-field"].dtUrlRule(this.dtUrl) !== "boolean"
      ) {
        this.$toast.clear();
        this.$toast.error("آدرس وارد شده صحیح نمی‌باشد!");
        return;
      }

      this.loading = true;
      let obj = {
        type: "pricelabel", 
        qrType: "dynamic",
        title: this.cardTexts.visitName,
        domain_id: this.domainId,
        data: JSON.stringify({
          theme: this.theme,
          data: this.cardTexts,
        }),
        qr: JSON.stringify(this.qrDesign),
      };
      if (this.dtUrl && this.dtUrl.length > 0) {
        obj.identifier = this.dtUrl;
      }

      this.$api
        .post("/v1/testQr/store", obj)
        .then(({ data }) => {
          this.loading = false;
          this.info = data.data;
          this.createdDomain = this.$refs["address-field"].destItems.find(
            (item) => item.id === this.domainId,
          ).name;
          this.createdId = data.data.identifier;
          this.updateQridentifier(data.data.identifier);
          this.updateQrId(data.data.id);
          this.updateQrInfo(data.data);
          this.updateQrDomain(data.data.domain_id);
          this.$toast.success("لیبل قیمت شما با موفقیت ساخته شد.");
          if (this.e6 === 1) {
            this.e6 = 2;
            this.$nextTick(() => {
              setTimeout(() => {
                this.$refs.qrCanvas.appendCanvas(data.data.link);
              }, 500);
              setTimeout(() => {
                this.qrUpdate(false);
              }, 2000);
            });
          }
        })
        .catch((error) => {
          const response = error.response;
          if (response?.status === 422) {
            this.$modal.error("خطا", response.data.message);
          }
          this.$toast.error(this.$t("qr_creation_failed") || "خطا در ایجاد کیوآر");
        })
        .finally(() => {
          this.loading = false;
        });
    },

    qrUpdate(final = false) {
      if (this.loading || this.isAutoSaving) return;

      if (final || !this.AutoSave) {
        this.loading = true;
      } else {
        this.isAutoSaving = true;
      }

      const data = new FormData();
      data.append("type", "pricelabel");
      data.append("image", this.qrSvgDataUrl);
      data.append("qrType", "dynamic");
      data.append("domain", this.createdDomain);
      data.append("identifier", this.createdId || "");
      data.append("qr_id", this.info.qrId);
      data.append("_method", "PUT");
      data.append(
        "data",
        JSON.stringify({
          theme: this.theme,
          data: this.cardTexts,
        }),
      );
      data.append("qr", JSON.stringify(this.qrDesign));

      this.$api
        .post("/v1/testQr/update", data)
        .then(() => {
          if (final || !this.AutoSave) {
            this.$toast.success("کیوآر لیبل قیمت با موفقیت به‌روزرسانی شد.");
          }
          final && this.$router.push("/qr/list");
        })
        .catch(() => {
          this.$toast.error("خطا در بروزرسانی اطلاعات لیبل قیمت");
        })
        .finally(() => {
          this.loading = false;
          this.isAutoSaving = false;
        });
    },

    clearDefaults() {
      this.$root.$emit("clearDefaultData");
      this.cardTexts.visitName = "";
      this.cardTexts.label = {
        name: { text: "", line: false },
        labelName: { text: "", line: false },
        price: { text: 0, line: false },
        bPrice: { text: 0, line: false },
        cPrice: { text: 0, line: false },
        discount: { text: null, line: false },
        discriptions: { text: "", line: false },
      };
    },
  },
};
</script>

<style scoped>
.v-tab--active {
  background-color: var(--v-primary-base) !important;
  border-radius: 50px;
  color: white;
}
</style>
